import AbnrmDectNoti from '@/views/appmgmt/abnrm/index.vue'

export default [
  {
    path: '/appmgmt/abnrmDetc',
    name: 'AbnrmDectNoti',
    component: AbnrmDectNoti,
    meta: {
      authRequired: false,
      desc: '이상감지 내역'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/appmgmt/index.js